"use client";

import { PriceCalculator } from "@/components/shared/public";
import type { PricingConfig } from "@/lib/pricing";
import { useTranslations } from "next-intl";

type PriceCalculationProps = {
  pricingConfig: PricingConfig;
};

const PriceCalculation = ({ pricingConfig }: PriceCalculationProps) => {
  const t = useTranslations("common");

  return (
    <PriceCalculator
      id={"section-4"}
      orderHref="/user/order-sized-floor-plan"
      paidOptions={[
        { name: "living_space_calculation", label: t("calcPerFloor") },
        { name: "architect_confirmation", label: t("architectConfirmation") },
        {
          name: "360_as_input",
          label: t("threeSixtyCreation"),
        },
        {
          name: "data_transfer_matterport_point_cloud",
          label: t("matterportTransfer"),
        },
        {
          name: "total_living_space_with_architects_confirmation",
          label: t("totalLivingConf"),
        },
        { name: "dwg_file", label: t("dwgFile") },
        { name: "sales_optimized_extra_floor_plan", label: t("salesOptExt") },
      ]}
      freeOptions={[
        { name: "Möblierung", label: t("furnishings") },
        { name: "Küchenausstattung", label: t("kitchenEquipment") },
        { name: "Badezimmerausstattung", label: t("bathroomEquipment") },
        { name: "Eingangspfeil", label: t("entranceArrow") },
        { name: "Nordpfeil", label: t("northArrow") },
        { name: "Zimmernamen", label: t("roomNames") },
        { name: "Maßstab", label: t("scale") },
        { name: "Quadratmeter pro Raum", label: t("squareMetersPerRoom") },
        { name: "Factsheet", label: t("factsheet") },
      ]}
      pricingConfig={pricingConfig}
    />
  );
};

export default PriceCalculation;
